<div fxLayout="row" fxLayoutAlign="start center">
  <neq-select-autocomplete #select fxFlex="75"
    [dataSource]="multiSelectInput.fetchChoices"
    [multipleCheckBox]="true"
    [(ngModel)]="multiSelectInput.allSelectedValues"
    [defaultLabel]="multiSelectInput.placeholderKey | translate"
    [bindLabel]="bindLabel" [disabled]="disabled"
    [paginatedResults]="paginatedResults"
    (change)="onChange()"
  >
  </neq-select-autocomplete>
  <div>{{ multiSelectInput.nbTotal }} {{ multiSelectInput.keyAfterTotal | translate }}</div>
</div>


